import { render, staticRenderFns } from "./VEmployerServicesInviteCandidate.vue?vue&type=template&id=e124cb0a&lang=pug"
import script from "./VEmployerServicesInviteCandidate.vue?vue&type=script&lang=ts"
export * from "./VEmployerServicesInviteCandidate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EmployerServicesInviteCandidate.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fpages%2FLayout%2Fviews%2FEmployer%2Fviews%2FServices%2FInviteCandidate%2FVEmployerServicesInviteCandidate.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports